import AuthRegisterWebauthnView from "./auth-register-webauthn.html";
import AuthRegisterYubicoOTPView from "./auth-register-yubicootp.html";

angular.module("auth", [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('authinit', {
                url: "/auth/init",
                views: {
                    'loginContent': {
                        template: '<auth-login></auth-login>'
                    }
                }
            })
            .state('login', {
                url: "/login",
                views: {
                    'loginContent': {
                        template: '<auth-login></auth-login>'
                    }
                }
            })
            .state('authregisterauthcode', {
                url: "/auth/register/authcode/:token",
                views: {
                    'loginContent': {
                        template: '<auth-register-auth-code></auth-register-auth-code>'
                    }
                }
            })
            .state('authregisterwebauthn', {
                url: "/auth/register/webauthn/:token",
                views: {
                    'loginContent': {
                        controller: "AuthRegisterWebauthnCtrl",
                        template: AuthRegisterWebauthnView,
                    }
                }
            })
            .state('authregisteryubicootp', {
                url: "/auth/register/yubicootp/:token",
                views: {
                    'loginContent': {
                        controller: "AuthRegisterYubicoOTPCtrl",
                        template: AuthRegisterYubicoOTPView,
                    }
                }
            })
            .state('authresetpassword', {
                url: "/auth/reset-password?token",
                views: {
                    'loginContent': {
                        template: '<auth-reset-password></auth-reset-password>'
                    }
                }
            })
            .state('oauthloading', {
                url: "/oauth-loading",
                views: {
                    'loginContent': {
                        template: '<auth-oauth-loading></auth-oauth-loading>'
                    }
                }
            })
    }]);
